import { render } from "./VillagerPowerModal.vue?vue&type=template&id=0366a5e0&scoped=true"
import script from "./VillagerPowerModal.vue?vue&type=script&lang=js"
export * from "./VillagerPowerModal.vue?vue&type=script&lang=js"

import "./VillagerPowerModal.vue?vue&type=style&index=0&id=0366a5e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366a5e0"]])

export default __exports__